
import LoginTemplate from '@/components/LoginTemplate'
import { loadScript } from '@/utils/validate'
import { openWxFollow } from '@/settings'
import { mapGetters } from 'vuex'
import { pzLoginStorage } from '@/utils'
import NewUserCoupon from "@/components/NewUserCoupon"
export default {
    components: {
        LoginTemplate,
        NewUserCoupon
    },
    head() {
        return {
            title: this.$config.isPublicProd ? '登录-盼之代售' : '测试',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.$config.isPublicProd
                        ? '盼之代售账号登录，盼之代售专业正规的游戏账号交易平台，提供网游交易售卖，手游账号买号卖号服务。王者荣耀账号出售，穿越火线cf卖号交易，英雄联盟lol买号交易，原神账号交易充值等'
                        : ''
                },
                {
                    hid: 'keywords',
                    name: 'keywords',
                    content: this.$config.isPublicProd ? '登录，盼之代售' : ''
                }
            ]
        }
    },
    data() {
        return {
            passwordType: 'password',
            verification: true,

            showLogo: false,
            qrLoading: false,
            navTitleIndex: '手机验证码',
            navTitle: ['手机验证码', '密码登录'],
            activeName: 'login',
            isWeiXinLogin: false,
            submitLoading: false,
            ruleForm: {
                username: null,
                password: null
            },
            rules: {
                username: [
                    {
                        required: true,
                        message: '请输入用户名或手机号码',
                        trigger: 'blur'
                    }
                ],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                code: [{ required: true, message: '请输入短信验证码', trigger: 'blur' }]
            },
            // 手机验证码
            ruleFormByPhone: {
                mobile: '',
                code: '',
                inviteCode: null
            },
            rulesByPhone: {
                mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    {
                        pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
                        required: true,
                        message: '请输入正确的手机号',
                        trigger: 'blur'
                    }
                ],
                code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
            },
            count: 0,
            smsLoading: false,
            show: true,
            phoneSate: false,
            timer: null,
            redirect: undefined,
            ie: false,
            checked: false,
            isShowCouponDialog: false,
            shouldHideInviteCode: false
        }
    },
    watch: {
        $route: {
            handler: function (route) {
                this.redirect = route.query && route.query.redirect
                // 检查路由中是否包含 inviteCode 参数
                this.shouldHideInviteCode = !!(route.query && route.query.inviteCode)
                if(this.shouldHideInviteCode){
                    this.ruleFormByPhone.inviteCode = route.query.inviteCode
                }
            },
            immediate: true
        },
        isWeiXinLogin(v) {
            // 切换的时候删除iframe元素
            if (!v) document.getElementsByTagName('iframe')[0].style.display = 'none'
        }
    },
    computed: {
        ...mapGetters({
            thirdUserInfo: 'user/thirdUserInfo',
            userinfo: 'user/userinfo',
            token: 'user/token',
            wbxdId: 'wbxdId',
            keyword : 'keyword',
            pzfrom:'pzfrom'
        })
    },
    mounted() {
        if (!this.token) pzLoginStorage().onRemove()
        this.ie = !!window.ActiveXObject || 'ActiveXObject' in window
    },
    created() {
        // 请重新进行微信扫码授权就重新显示二维码
        if (this.$route.params.openCode) {
            this.isWeiXinLogin = true
        }
        if (!openWxFollow) this.showLogo = true
        if(this.wbxdId) this.ruleFormByPhone.inviteCode = this.wbxdId
    },
    methods: {
        onCheckLogin() {
            const loginLoggedIn = [pzLoginStorage().status.pending, pzLoginStorage().status.loggedIn].includes(localStorage.getItem(pzLoginStorage().key))
            if (loginLoggedIn) {
                this.$alert('系统检测到您已登录，请点击确定刷新页面', '提示', {
                    confirmButtonText: '确定',
                    customClass: 'check-login',
                    type: 'error'
                })
                    .then(() => {
                        window.location.reload()
                    })
                    .catch(() => { })
                return false
            } else {
                return true
            }
        },
        changeTitle(item) {
            this.navTitleIndex = item
        },
        // 倒计时
        getCode() {
            const TIME_COUNT = 60
            if (!this.timer) {
                this.count = TIME_COUNT
                this.show = false
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--
                    } else {
                        this.show = true
                        clearInterval(this.timer)
                        this.timer = null
                        this.submitLoading = false
                    }
                }, 1000)
            }
        },
        // 发送短信
        sendSms() {
            if (this.ie) {
                this.$message.warning('您当前使用的IE内核，为了您更好的浏览体验建议使用谷歌浏览器，或QQ浏览器切换为极速模式。')
                return
            }
            if (this.ruleFormByPhone.mobile === '') {
                this.$message.error('请输入手机号')
                this.$refs.mobile.focus()
                return false
            }
            this.smsLoading = true
            let data = {
                action: {
                    phone: this.ruleFormByPhone.mobile,
                    smsTemplate: 'LOGIN'
                }
            }

            this.$store
                .dispatch('user/UserSendSms', data)
                .then(res => {
                    this.smsLoading = false
                    if (res.success) {
                        this.$message.success('短信验证码已发送，请注意查收')
                        this.getCode()
                        this.$refs.code.focus()
                        return false
                    } else {
                        this.$message.warning(res.info)
                    }
                })
                .catch(() => {
                    this.smsLoading = false
                    this.timer = null
                })
        },
        showPhoneLoginBox(phoneSate, loginSate) {
            this.phoneSate = phoneSate
            this.loginSate = loginSate
            this.ruleFormByPhone.code = ''

            // 切换清除错误提示
            if (this.phoneSate) {
                this.$nextTick(() => {
                    this.$refs['ruleFormByPhone'].clearValidate()
                })
            }
            if (this.loginSate) {
                this.$nextTick(() => {
                    this.$refs['ruleForm'].clearValidate()
                })
            }
        },
        /**
         * 选择微信登录
         * 内嵌
         */
        checkWx() {
            this.showLogo = true
            this.qrLoading = true
            this.isWeiXinLogin = true
            const wechatSDK = 'https://pzdsoss.pzds.com/version/app/android/wxLogin.js'
            loadScript('js', wechatSDK)
                .then(() => {
                    let p = {
                        action: {
                            thirdType: 'WECHAT'
                        }
                    }
                    this.$api.thirdUrl(p).then(res => {
                        if (!res.success) {
                            this.$message.error(res.info)
                            return
                        }
                        let data = res.data
                        new WxLogin({
                            id: 'wechatLogin', // 需要显示的容器id
                            appid: data.appId, // 公众号appid wx*******
                            scope: 'snsapi_login', // 网页默认即可
                            redirect_uri: encodeURIComponent(data.redirectUri), // 授权成功后回调的url
                            state: data.state, // 可设置为简单的随机数加session用来校验
                            style: 'black', // 提供"black"、"white"可选。二维码的样式
                            href: 'https://pzdsoss.pzds.com/version/app/android/wxCode.css' // 外部css文件url，需要https
                        })
                        this.qrLoading = false
                    })
                })
                .catch(() => {
                    this.qrLoading = false
                    this.isWeiXinLogin = false
                    this.$message.error('资源加载失败')
                })
        },
        closeWechat() {
            openWxFollow ? (this.showLogo = false) : (this.showLogo = true)
            this.isWeiXinLogin = false
            // 点击账号登录的时候，隐藏iframe框
            document.getElementsByTagName('iframe')[0].style.display = 'none'
        },
        checkQq() {
            // let params = {}
            const url = 'https://graph.qq.com/oauth2.0/authorize?which=Login&display=pc&response_type=code&client_id=101876227&redirect_uri=https://v2.zuiwanjia.com/qqCallback'
            window.open(url)
        },
        submitForm(formName) {
            if (this.ie) {
                this.$message.warning('您当前使用的IE内核，为了您更好的浏览体验建议使用谷歌浏览器，或QQ浏览器切换为极速模式。')
                return
            }
            // 登录中
            const checkLogin = this.onCheckLogin()
            if (!checkLogin) return

            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    let params = {
                        action: {
                            phone: this.ruleForm.username.trim(),
                            password: this.ruleForm.password,
                            openId: (this.thirdUserInfo && this.thirdUserInfo.openId) || null,
                            thirdType: (this.thirdUserInfo && this.thirdUserInfo.thirdType) || null,
                            unionId: (this.thirdUserInfo && this.thirdUserInfo.unionId) || null,
                            adExtras: sessionStorage.ad_extras,
                            pzfrom: sessionStorage.pzfrom,
                            channelCode: sessionStorage.pzfrom
                        }
                    }
                    pzLoginStorage().onPending()
                    this.$store
                        .dispatch('user/UserLogin', params)
                        .then(async res => {
                            this.submitLoading = false
                            if (res.success) {
                                // window.localStorage.setItem('userLoggedIn', 'false')
                                // 删除第三方数据
                                this.$store.commit('user/THIRD_USERINFO', null)
                                this.$message.success('登录成功')
                                await this.$store.dispatch('user/UserGetInfo')
                                this.$sensors?.login(this.userinfo.id)
                                this.$api.getImInfo().then(({ success, data }) => {
                                    if (success) {
                                        this.$store.dispatch('ry/initConnect', data)
                                    }
                                })
                                // 砍价盒子列表
                                this.$store.dispatch('bargaining/getBargainBoxList')
                                // 砍价消息未读数量
                                this.$store.dispatch('bargaining/getBargainUnReadMessageCount')
                                pzLoginStorage().onLoggedIn()
                                if (this.$route.params.path) {
                                    this.$router.push(`/goodsList/${this.$route.params.path}/6`)
                                    return false
                                }
                                if (this.redirect === '/registered') {
                                    this.$router.replace('/')
                                } else {
                                    this.$router.replace(this.redirect || '/')
                                }
                                return false
                            } else {
                                pzLoginStorage().onRemove()
                                this.$message.error(res.info)
                            }
                        })
                        .catch(() => {
                            this.submitLoading = false
                            pzLoginStorage().onRemove()
                        })
                } else {
                    return false
                }
            })
        },
        // 手机登录 todo 注册逻辑
        submitFormByPhone(formName) {
            if (this.ie) {
                this.$message.warning('您当前使用的IE内核，为了您更好的浏览体验建议使用谷歌浏览器，或QQ浏览器切换为极速模式。')
                return
            }

            if (!this.checked) {
                this.$message.error('请勾选服务协议')
                return
            }
            // 登录中
            const checkLogin = this.onCheckLogin()
            console.log('🚀 ~ submitFormByPhone ~ checkLogin:', checkLogin)
            if (!checkLogin) return
            console.log(this.$route.params);

            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    let params = {
                        action: {
                            phone: this.ruleFormByPhone.mobile,
                            smsCode: this.ruleFormByPhone.code,
                            openId: (this.thirdUserInfo && this.thirdUserInfo.openId) || null,
                            thirdType: (this.thirdUserInfo && this.thirdUserInfo.thirdType) || null,
                            unionId: (this.thirdUserInfo && this.thirdUserInfo.unionId) || null,
                            channelCode: window.localStorage.getItem('pzfrom') || null,
                            inviteCode: this.$route.query.inviteCode ? this.$route.query.inviteCode : this.ruleFormByPhone.inviteCode,
                            shibbolethId: this.$route.params.key === 'undefined' ? undefined : this.$route.params.key,
                            adExtras: sessionStorage.ad_extras,
                            pzfrom: sessionStorage.pzfrom,
                            channelCode: sessionStorage.pzfrom

                        }
                    }
                    // 微博小店chan参数
                    if(this.wbxdId){
                        const chanValue = this.keyword || ''
                        params.action.chan = chanValue.length > 50 ? chanValue.slice(0, 50) : chanValue
                    }
                    pzLoginStorage().onPending()
                    this.$store
                        .dispatch('user/UserMobileLogin', params)
                        .then(async res => {
                            this.submitLoading = false
                            if (res.success) {
                                // window.localStorage.setItem('userLoggedIn', 'false')
                                // 删除第三方数据
                                this.$store.commit('user/THIRD_USERINFO', null)
                                // 删除wbxdId于关键字
                                if(this.wbxdId) {
                                    this.$store.commit('SET_WBXD_ID', null)
                                    this.$store.commit('SET_SEARCH_WORD', null)
                                }
                                this.$message.success('登录成功')
                                await this.$store.dispatch('user/UserGetInfo')
                                this.$sensors?.login(this.userinfo.id)
                                window.localStorage.removeItem('pzfrom')
                                this.$api.getImInfo().then(({ success, data }) => {
                                    if (success) {
                                        this.$store.dispatch('ry/initConnect', data)
                                    }
                                })

                                // 砍价盒子列表
                                this.$store.dispatch('bargaining/getBargainBoxList')
                                // 砍价消息未读数量
                                this.$store.dispatch('bargaining/getBargainUnReadMessageCount')
                                pzLoginStorage().onLoggedIn()

                                // 新人优惠券： 1.注册 2.打开了优惠券开关
                                if (res && res.data && res.data.openAward && res.data.register) {
                                    this.showCouponDialog()
                                    return
                                }

                                return this.onLoginJump();
                            } else {
                                pzLoginStorage().onRemove()
                                if (res.info.indexOf('手机号尚未进行注册') !== -1) {
                                    this.$confirm(res.info, '', {
                                        confirmButtonText: '前往注册',
                                        confirmButtonClass: 'confirmButtonClass',
                                        type: 'info'
                                    }).then(() => {
                                        this.$router.push('/registered')
                                    })
                                    return
                                }
                                this.$message.error(res.info)
                            }
                        })
                        .catch(() => {
                            this.submitLoading = false
                            pzLoginStorage().onRemove()
                        })
                } else {
                    return false
                }
            })
        },
        onLoginJump() {
            if (this.$route.params.path) {
                this.$router.push(`/goodsList/${this.$route.params.path}/6`)
                return false
            }
            if (this.redirect === '/registered') {
                this.$router.replace('/')
            } else {
                this.$router.replace(this.redirect || '/')
            }
            return false
        },
        blurPassword() {
            let passwordPattern =
                /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d\S]{8,16}$|^(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$|^(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$|^(?=.*[a-z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d\S]{8,16}$/
            this.verification = passwordPattern.test(this.ruleForm.password)
        },
        showPwd() {
            if (this.passwordType === 'password') {
                this.passwordType = ''
            } else {
                this.passwordType = 'password'
            }
            this.$nextTick(() => {
                this.$refs.password.focus()
            })
        },
        // handleRegister() {
        //     let url = '/registered';
        //     this.redirect && ( url = url + "?redirect=" + this.redirect)
        //     this.$router.push(url)
        // },
        showCouponDialog() {
            this.isShowCouponDialog = true;
        },
        closeCouponDialog() {
            this.isShowCouponDialog = false;
            this.onLoginJump()
        }
    }
}
